import { IPositionType } from '../generated-types/position-type'

export const compareByReference = (a?: string | null, b?: string | null): number => {
  const refA = a ?? ''
  const refB = b ?? ''
  return refA.localeCompare(refB, 'en', { numeric: true, sensitivity: 'base' })
}

const compareByNumericName = (a?: string | null, b?: string | null): number =>
  (parseInt(a ?? '', 10) || 0) - (parseInt(b ?? '', 10) || 0)

export const sortPositionsByReference = <T extends { name: string; type?: IPositionType; reference?: string }>(
  a: T,
  b: T,
): number => {
  if (a.type === IPositionType.Cage && b.type === IPositionType.Cage) {
    const aHasReference = !!a.reference
    const bHasReference = !!b.reference
    if (aHasReference !== bHasReference) return aHasReference ? -1 : 1
    return aHasReference ? compareByReference(a.reference, b.reference) : compareByNumericName(a.name, b.name)
  }
  return compareByNumericName(a.name, b.name)
}

export const compareCagesByReference = (
  a: { name?: string | null; reference?: string | null },
  b: { name?: string | null; reference?: string | null },
): number => {
  const aHasReference = !!a.reference
  const bHasReference = !!b.reference
  if (aHasReference !== bHasReference) return aHasReference ? -1 : 1
  return aHasReference ? compareByReference(a.reference, b.reference) : compareByReference(a.name, b.name)
}
